import type { ReactNode } from "react";
import { useAuth } from "@/components/auth-context";
import { LoadingLine } from "@/components/primitives";
import { shouldShowMaintenance } from "@/lib/maintenance";
import { AuthPage } from "@/pages/auth-page";

export function MaintenanceGate({ children }: { children: ReactNode }) {
  const {
    user,
    loading,
    publicConfigLoading,
    maintenanceEnabled,
    restoringSession,
  } = useAuth();

  if (publicConfigLoading || restoringSession || (maintenanceEnabled && loading)) {
    return <div className="center-screen"><LoadingLine /></div>;
  }
  if (shouldShowMaintenance(maintenanceEnabled, user?.roles)) {
    return <AuthPage initialMode="login" />;
  }
  return children;
}
